import { Component, OnInit } from '@angular/core';
/**
 * Display * on all fields that are required
 */
@Component({
  selector: 'app-required-label',
  templateUrl: './required-label.component.html',
  styleUrls: ['./required-label.component.scss']
})
export class RequiredLabelComponent implements OnInit {
  /**
   * constructor to inject dependency
   */
  constructor() {}
  /**
   * initialize component
   */
  ngOnInit(): void {}
}
